import type { BaseKeyFunction } from "../../../lib";

export const keyAvatars: BaseKeyFunction = () => ["avatars"];
